import {Injectable} from '@angular/core';
import {
    AuthHttpHeaderService,
    AuthRedirectService,
    AuthService,
    AuthStorageService,
    GlobalMessageService,
    GlobalMessageType,
    OAuthLibWrapperService,
    OccEndpointsService,
    RoutingService
} from '@spartacus/core';
import {AuthService as SSOAuth} from '@auth0/auth0-angular';

@Injectable({
    providedIn: 'root',
})
export class GenAuthHttpHeaderService extends AuthHttpHeaderService {

    constructor(
        protected override authService: AuthService,
        protected override authStorageService: AuthStorageService,
        protected override oAuthLibWrapperService: OAuthLibWrapperService,
        protected override routingService: RoutingService,
        protected override globalMessageService: GlobalMessageService,
        protected occEndpointsService: OccEndpointsService,
        protected override authRedirectService: AuthRedirectService,
        private ssoAuth: SSOAuth
    ) {
        super(
            authService,
            authStorageService,
            oAuthLibWrapperService,
            routingService,
            occEndpointsService,
            globalMessageService,
            authRedirectService
        );
    }

    override handleExpiredRefreshToken(): void {
        this.authService.coreLogout().finally(() => {
            this.ssoAuth.loginWithRedirect();
            this.globalMessageService.add(
                {key: 'httpHandlers.sessionExpired'},
                GlobalMessageType.MSG_TYPE_ERROR
            );
        });
    }
}